:host {
  display: flex;
  flex-direction: column;
  gap: $xp-ref-spacing-5;
}

h3 {
  font: $xp-ref-font-headline-headline03;
  color: $xp-ref-color-text-default-dark;
  margin: unset;
  overflow-wrap: anywhere;
}

.subtitle {
  font: $xp-ref-font-paragraph-paragraph-small;
  color: $xp-ref-color-text-default-medium;
}
